var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_82","data-name":"Path 82","d":"M27.521-11.666a16.613,16.613,0,0,1-4.9-.773,1.308,1.308,0,0,0-1.354.322L18.24-9.088a20.648,20.648,0,0,1-9.088-9.088l3.029-3.029a1.359,1.359,0,0,0,.322-1.354,15.628,15.628,0,0,1-.838-4.963,1.345,1.345,0,0,0-.387-.935,1.261,1.261,0,0,0-.967-.419H5.479a1.294,1.294,0,0,0-.935.419,1.294,1.294,0,0,0-.419.935,22.557,22.557,0,0,0,6.832,16.564A22.557,22.557,0,0,0,27.521-4.125a1.294,1.294,0,0,0,.935-.419,1.294,1.294,0,0,0,.419-.935v-4.834a1.261,1.261,0,0,0-.419-.967A1.345,1.345,0,0,0,27.521-11.666Z","transform":"translate(-4.125 28.875)","fill":"#f7f7f7"}));
}

PhoneInline.defaultProps = {"width":"24.75","height":"24.75","viewBox":"0 0 24.75 24.75"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
